import React, {Fragment} from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import {Button, Card, CardBody, CardFooter, Col, Row} from "reactstrap";
import UserTable from "Pages/Admin/Users/UsersTable";
import PageHeading from "Layout/AppMain/PageHeading";


const Default = () => {
    
    return (
        <Fragment>
           <div className="d-flex justify-content-between align-items-center">
                <PageHeading/>
            
            </div>
            <TransitionOnLoad>
                    <div>
                     
                        <Row>
                            <Col md="12">
                                <Card className="main-card mb-3">
                                    <CardBody className="p-3">
                                        <UserTable/>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </TransitionOnLoad>
           
        </Fragment>
    )
};

export default Default;
